import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LunexRoutingModule } from './lunex-routing.module';

import { OrderComponent } from './order/order.component';
import { OrdersComponent } from './orders/orders.component';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SettingsModule } from '../profile/settings.module';
import { SuperAdminRoutingModule } from '../super-admin/super-admin-routing.module';
import { PTOOrdersComponent } from './pto-orders/pto-orders.component';
import { PaypalOrdersComponent } from './paypal-orders/paypal-orders.component';
import { StripeOrdersComponent } from './stripe-orders/stripe-orders.component';
import { TopupVtComponent } from './topup-vt/topup-vt.component';
import { VcardTrnxComponent } from './vcard-trnx/vcard-trnx.component';
import { worldnetComponent } from './worldnet/worldnet-orders.component';
import { SamerchantTrxnsComponent } from '../dashboard/components/samerchant-trxns/samerchant-trxns.component';

@NgModule({
  declarations: [
    OrderComponent,
    OrdersComponent,
    PTOOrdersComponent,
    PaypalOrdersComponent,
    StripeOrdersComponent,
    TopupVtComponent,
    VcardTrnxComponent,
    worldnetComponent,
    SamerchantTrxnsComponent,
  ],
  imports: [
    CommonModule,
    LunexRoutingModule,
    CommonModule,
    MaterialModule,
    SettingsModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class LunexModule { }
